/* src/services/VoucherService.js */
import apiClient from './api'

export default {

  getVouchers() {
  
    return apiClient.get('/booking/vouchers/')
  },
  
  getVoucher(id) {
    
    return apiClient.get(`/booking/vouchers/${id}/`)
  },

  refundVoucher(code) {
  
    return apiClient.post('/booking/vouchers/redeem/', { code: code })
  },
}
